/**
 * سجلّ «البلوكات المبسَّطة» — مصدر حقيقة واحد للوحة /admin/home-blocks-simple.
 * كلّ بلوك يُدار بأربعة عناصر فقط: صورة + عنوان + نصّ + زرّ (رابط).
 * المفتاح هو نفس مفتاح app_settings المستخدَم في runtime البلوك.
 */
export type SimpleBlockDef = {
  key: string;
  ar: string;
  en: string;
  /** رقم البلوك في الهوم (للعرض فقط) */
  number?: number;
  hasImage?: boolean;
  hasBody?: boolean;
  hasCta?: boolean;
  /** مفاتيح React Query التي تُبطَل بعد الحفظ */
  invalidate?: string[];
  /** لوحة متقدّمة لبقيّة الحقول */
  advancedHref?: string;
  hintAr?: string;
};

export const SIMPLE_BLOCKS: SimpleBlockDef[] = [
  {
    key: "home_about_block",
    ar: "بلوك ٢",
    en: "Block 2",
    number: 2,
    hasImage: true,
    hasBody: true,
    hasCta: true,
    invalidate: ["home-about-block"],
    advancedHref: "/admin/home-about",
  },
  {
    key: "home_about_block_2",
    ar: "بلوك ٣",
    en: "Block 3",
    number: 3,
    hasImage: true,
    hasBody: true,
    hasCta: true,
    invalidate: ["home-about-block"],
    advancedHref: "/admin/home-about?slot=secondary",
    hintAr: "بنفس مقاس بلوك ٢ تماماً — اتركه فارغاً ليظهر كمساحة فقط.",
  },
  {
    key: "home_about_block_3",
    ar: "بلوك ٤",
    en: "Block 4",
    number: 4,
    hasImage: true,
    hasBody: true,
    hasCta: true,
    invalidate: ["home-about-block"],
    advancedHref: "/admin/home-about?slot=tertiary",
    hintAr: "بنفس مقاس بلوك ٢ تماماً — اتركه فارغاً ليظهر كمساحة فقط.",
  },
  {
    key: "home_soft_banner",
    ar: "بلوك ٥",
    en: "Block 5",
    number: 5,
    hasImage: true,
    hasBody: true,
    hasCta: true,
    invalidate: ["home-soft-banner"],
    advancedHref: "/admin/home-soft-banner",
  },
  {
    key: "home_editorial_note",
    ar: "بلوك ٦",
    en: "Block 6",
    number: 6,
    hasImage: false,
    hasBody: true,
    hasCta: false,
    invalidate: ["home-editorial-note"],
    advancedHref: "/admin/home-editorial-note",
  },
  {
    key: "home_story_banner",
    ar: "بلوك ٨",
    en: "Block 8",
    number: 8,
    hasImage: true,
    hasBody: true,
    hasCta: true,
    invalidate: ["home-story-banner"],
    advancedHref: "/admin/home-story-banner",
    hintAr: "الصورة هنا هي البوستر (الفيديو يُدار من اللوحة المتقدّمة).",
  },
];

export const SIMPLE_BLOCK_KEYS = SIMPLE_BLOCKS.map((b) => b.key);

/** الحقول الوحيدة التي تسمح اللوحة المبسَّطة بتعديلها (الباقي يبقى كما هو) */
export type SimpleBlockFields = {
  enabled: boolean;
  imageUrl: string;
  /** وضع الصورة: كولاج صغير (افتراضي) أو صورة كاملة كخلفية للبلوك */
  imageMode: "collage" | "full";
  /** لون خلفيّة البلوك (hex) — يُستخدم بدلاً من الصورة عندما تكون الصورة فارغة */
  bgColor: string;
  /** الجهاز الذي يظهر فيه البلوك */
  devices: "all" | "mobile" | "desktop";
  titleAr: string;
  titleEn: string;
  bodyAr: string;
  bodyEn: string;
  ctaLabelAr: string;
  ctaLabelEn: string;
  ctaHref: string;
};

export const EMPTY_SIMPLE_FIELDS: SimpleBlockFields = {
  enabled: true,
  imageUrl: "",
  imageMode: "collage",
  bgColor: "",
  devices: "all",
  titleAr: "",
  titleEn: "",
  bodyAr: "",
  bodyEn: "",
  ctaLabelAr: "",
  ctaLabelEn: "",
  ctaHref: "",
};

/** كلاس Tailwind يخفي البلوك على الجهاز غير المستهدَف (SSR-safe، بلا unmount) */
export function deviceVisibilityClass(devices?: SimpleBlockFields["devices"]): string {
  if (devices === "mobile") return "md:hidden";
  if (devices === "desktop") return "hidden md:block";
  return "";
}

/** ربط مفاتيح بلوكات الهوم (LabeledBlock) بمفاتيح app_settings */
export const HOME_BLOCK_SETTINGS_KEY: Record<string, string> = {
  AboutIntro: "home_about_block",
  AboutIntroTwo: "home_about_block_2",
  AboutIntroThree: "home_about_block_3",
  HomeSoftBanner: "home_soft_banner",
  HomeEditorialNote: "home_editorial_note",
  HomeStoryBanner: "home_story_banner",
};
